import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { getRequest, HandlerResponse, postRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetFilteredData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/filter/getFilterInfo/${sessionStorage.getItem('userName')}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetTimeList = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/filter/getTimeFilterData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetLocationList = async (payload?: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  const url = `${Environment.API}/filter/getLocationFilterData${queryString}`;

  if (!!payload) {
    return postRequest(url, payload).then((resp: any) => HandlerResponse(resp));
  }
  return postRequest(url).then((resp: any) => HandlerResponse(resp));
};

export const GetProductHierarchyList = async (queryParams: any, payload?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/filter/getProductFilterData${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateTimeList = async (payload: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/filter/saveTimeFilterData/${sessionStorage.getItem('userName')}${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateLocationList = async (payload: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/filter/saveLocationFilterData/${sessionStorage.getItem('userName')}${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateProductHierarchyList = async (payload: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/filter/saveProductFilterData/${sessionStorage.getItem('userName')}${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateFilterData = async (payload: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/filter/saveAllFilterData/${sessionStorage.getItem('userName')}${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const DashboardCardData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/dashboard/cardData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const isLoginUserAdmin = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/filter/isLoginUserAdmin/${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};
